/**
 * 描述：共享稿库左侧
 * 日期：2017-8-21
 * 作者: Bai.Zhiming
 */
'use strict';
angular.module('shareLeftModule', [])
    .directive('shareLeft', ['$state', '$q', '$timeout', '$stateParams', 'trsHttpService', 'resourceCenterService', function($state, $q, $timeout, $stateParams, trsHttpService, resourceCenterService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                classify: '='
            },
            templateUrl: './resourceCenter/shared/left/left_tpl.html',
            link: function(scope, $attr, $elem) {

                initStatus();
                initData();

                /**
                 * [expandClassify description]
                 * @param {object} [classify] [description] 所选分类
                 * @param {object} [$event] [description] 
                 * @return {[type]} [description]
                 */
                scope.expandClassify = function(classify, $event) {
                    classify.isOpen = !classify.isOpen;
                    selectItem($event, classify, classify);
                };

                /**
                 * [selectItem description] 选择子分类
                 * @param {object} [$event] [description]
                 * @param {object} [item] [description] 子分类
                 * @param {object} [classify] [description]
                 * @return {[type]} [description]
                 */
                function selectItem($event, item, classify) {
                    if ($event.stopPropagation) {$event.stopPropagation();}
                    var nodeId, url;
                    nodeId = item.ID;
                    scope.status.parentNode = classify;
                    url = 'front.resourcectrl.share.resource';
                    var isUgc = '0';
                    var iscrosstenant = classify.ISCROSSTENANT && classify.ISCROSSTENANT == '1' ? '1' : '0';
                    if (angular.isDefined(classify.ISUGC) && classify.ISUGC == '1') {
                        isUgc = '1';
                    }
                    resourceCenterService.go(url, {
                        modalid: '37',
                        nodeid: nodeId,
                        parentid: item == classify ? '' : classify.ID,
                        nodename: item.dictName || item.CATEGORYNAME,
                        change: Math.random(0, 1) * 100,
                        isugc: isUgc == '1' ? '1' : '0',
                        manutype: item.ISGONGGAO === '1' ? 'countyFeedList' : '',
                        iscrosstenant: iscrosstenant
                    });
                    scope.status.selectedItem = item;
                }
                scope.selectItem = selectItem;

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        usualList: []
                    };
                    scope.data = {

                    };
                }

                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    let timer = $timeout(function() {
                        initLocation();
                    });
                    queryMyCustoms();
                }

                /**
                 * [initLocation description] 初始化定位
                 * @return {[type]} [description]
                 */
                function initLocation() {
                    if (!resourceCenterService.hasNavigationMemory('share', scope)) {
                        selectItem('', scope.classify[0], scope.classify[0]);
                        scope.classify[0].isOpen = true;
                    } else {
                        $timeout(function() {
                            initSelectClassify();
                        });
                    }
                }

                /**
                 * [getSelectedClassify description] 初始化分类
                 * @param {object} [classify] [description] 分类
                 * @return {[type]} [description]
                 */
                function initSelectClassify() {
                    if ($stateParams.parentid) { // 如果之前点击的是二级菜单
                        scope.status.parentNode = scope.classify.filter(function(item, index) {
                            return item.ID === $stateParams.parentid;
                        })[0];
                        if (scope.status.parentNode) { // 如果找到了相应的父级菜单
                            scope.status.parentNode.isOpen = true;
                            if (scope.status.parentNode.CHILDLIST instanceof Array) {
                                scope.status.selectedItem = scope.status.parentNode.CHILDLIST.filter(function(item, index) {
                                    return item.ID == $stateParams.nodeid;
                                })[0];
                            }
                        }
                    } else { // 如果之前点击的是一级菜单
                        if ($stateParams.nodeid) {
                            scope.status.selectedItem = scope.classify.filter(function(item, index) {
                                return item.ID === $stateParams.nodeid;
                            })[0];
                        } else {
                            selectItem('', scope.classify[0], scope.classify[0]);

                        }
                    }
                }

                /**
                 * [queryMyCustoms description] 查找常用列表
                 * @param  {Function} callback [description]
                 * @return {[type]}            [description]
                 */
                function queryMyCustoms() {
                    resourceCenterService.queryMyCustoms(2).then(function(data) {
                        scope.status.usualList = data.DATA;
                    });
                }

                /**
                 * [checkUsual description] 检查常用
                 * @param  {[type]} item [description] 被检查项
                 * @return {[type]}      [description]
                 */
                scope.checkUsual = function(item) {
                    for (var i = 0; i < scope.status.usualList.length; i++) {
                        var theItem = scope.status.usualList[i];
                        if (theItem.CUSTOMID === item.ID) {
                            return 'active icon-planresource_resourc9';
                        }
                    }
                };

                /**
                 * [setOrCancelUsual description] 设置或取消设为常用
                 * @param {[type]} item [description] 被设置项
                 * @param {[type]} $event [description]
                 * @return {[type]}      [description]
                 */
                scope.setOrCancelUsual = function(item, $event) {
                    $event.stopPropagation();
                    var flag = scope.checkUsual(item) === 'active icon-planresource_resourc9';
                    if (flag) {
                        resourceCenterService.cancleMyCustom({
                            CustomIds: item.ID,
                            CustomType: 2
                        }).then(function() {
                            for (var i = 0; i < scope.status.usualList.length; i++) {
                                var theItem = scope.status.usualList[i];
                                if (theItem.CUSTOMID === item.ID) {
                                    scope.status.usualList.splice(i, 1);
                                    break;
                                }
                            }
                        });
                    } else {
                        resourceCenterService.saveMyCustom({
                            Custom: item.CATEGORYNAME,
                            CustomId: item.ID,
                            CustomType: 2
                        }).then(function() {
                            scope.status.usualList.push({
                                CUSTOMID: item.ID
                            });
                        });
                    }
                };
            }
        };
    }]);
